<template>
  <div class="col-12">
    <div class="input-group mb-3">
      <input
        v-model="yorum"
        maxlength="120"
        ref="yorum"
        type="text"
        class="form-control form-control-sm rounded-pill me-1"
        placeholder="Yorum ekle"
        aria-label="Yorum ekle"
      />
      <button
        class="btn text-info rounded-circle"
        type="button"
        @click="comment"
        :disabled="!yorum"
      >
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { yorum: null };
  },
  created() {
    this.$nextTick(() => this.$refs.yorum.focus());
  },
  methods: {
    comment() {
      alert(this.yorum);
      this.yorum = null;
    },
  },
};
</script>

<style scoped>
.btn:hover {
  color: white;
  background-color: #cff5fc;
}
</style>
